export const ALLOWED_CONTENT_TYPES = [
  'application/pdf',
  'image/jpeg',
  'image/png',
] as const;

export type AllowedContentType = (typeof ALLOWED_CONTENT_TYPES)[number];

export const MAGIC_BYTES_MAP: Record<AllowedContentType, readonly number[]> = {
  'application/pdf': [0x25, 0x50, 0x44, 0x46],
  'image/jpeg': [0xff, 0xd8, 0xff],
  'image/png': [0x89, 0x50, 0x4e, 0x47],
};

export const EXTENSION_MAP: Record<AllowedContentType, string> = {
  'application/pdf': 'pdf',
  'image/jpeg': 'jpg',
  'image/png': 'png',
};

export const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5MB per file
export const MAX_TOTAL_UPLOAD_SIZE = 20 * 1024 * 1024; // 20MB total
export const MAX_FILE_COUNT = 20 as const;
export const UPLOAD_URL_TTL = 300 as const; // 5 minutes

export const PERSONAL_NUMBER_REGEX = /^\d{8}-\d{4}$/;
